var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 119,
    viewBox: "0 0 153 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.674 55.8085H0V64.7042H151.674V55.8085Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 118.416H9.2824V108.342H62.4077V73.5844H0V118.416ZM9.2824 82.4801H53.1253V99.4515H9.2824V82.4801Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4922 108.342H106.647V118.416H116.329V108.342H151.676V73.5844H71.4922V108.342ZM116.329 82.4801H142.393V99.4515H116.329V82.4801ZM80.7798 82.4801H106.647V99.4515H80.7798V82.4801Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.028 8.70631H149.206V0H105.719V8.88017V38.1546V46.8012H134.594C146.923 46.8012 152.006 40.6043 152.006 32.2561C152.006 24.0092 147.281 17.9316 134.889 17.9316H115.956V8.70631H139.028ZM134.889 26.5834C139.623 26.5834 141.429 29.2745 141.429 32.3755C141.429 35.4714 139.623 38.0949 134.889 38.0949H115.956V26.5834H134.889Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2707 38.0924H54.0625V46.8064H77.2179C90.9326 46.8038 100.269 37.3139 100.269 23.3967C100.269 9.47962 90.9326 0 77.2179 0H54.0625V8.70631H76.2707V8.72966C82.818 8.72966 87.6265 12.809 89.0953 19.1668H59.0735V27.6422H89.1005C87.6369 34.0078 82.8206 38.0924 76.2707 38.0924Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8585 12.8506C46.8585 5.14075 41.7204 0 29.381 0H0.046875V46.8012H31.1949C43.5291 46.8012 48.6102 41.1311 48.6102 33.3019C48.6102 28.1638 46.3914 24.3699 41.191 22.4314C45.1017 20.5007 46.8585 17.2362 46.8585 12.8506ZM10.2817 8.70631H29.7339C34.4102 8.70631 36.2812 11.5089 36.2812 14.4854C36.2812 17.4178 34.4699 19.7559 29.7339 19.7559H10.2817V8.70631ZM31.4908 38.1546H10.2817V26.8819H31.4908C36.2786 26.8819 38.0406 29.4535 38.0406 32.4819C38.0406 35.5337 36.2786 38.1546 31.4908 38.1546Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo-5.010229600b7dc3316908052b38a165fd.svg";
export { ForwardRef as ReactComponent };